import React, { useState } from 'react';
import moment from 'moment';

import { isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { RootState, renderNumber } from '@share/utils';
import { Switch } from 'antd';
import { getNextRewardByPriority } from '@utils';
import { getCurrencyText } from '@share/utils';

import { Currency } from '../currency';

import './style.scss';

interface IProps {
  display: boolean;
  onSelectReward: (selected: boolean) => void;
  currency?: string | null;
}

export function WalletRewardInput(props: IProps): React.ReactElement | null {
  const { display, onSelectReward, currency } = props;

  const [checked, setChecked] = useState(false);

  const loginStore = useSelector((state: RootState) => state.loginStore);
  const { account, userWalletReward } = loginStore;

  if (!display || isEmpty(userWalletReward) || !account?.enableWalletReward) {
    return null;
  }

  const allRewards = userWalletReward?.allRewards ?? [];
  const priority = account?.rewardWalletPriority;
  const selectedReward = getNextRewardByPriority(allRewards, priority);
  const rewardValue = selectedReward?.rewardValue ?? 0;
  const hasAvailableReward = !!selectedReward && rewardValue > 0;
  const expirationDateFormatted = selectedReward?.expirationDate
    ? moment(selectedReward.expirationDate).format('MM/DD/YYYY')
    : '';
  const amountFormatted = `${getCurrencyText(currency)}${renderNumber(rewardValue, 2)}`;

  const handleChange = (selected: boolean) => {
    setChecked(selected);
    onSelectReward(selected);
  };

  return (
    <div className="wallet-reward-input wallet-reward-input__container wallet-reward-input__card">
      <p className="wallet-reward-input__card-title">
        🎁 <FormattedMessage id="wallet.reward.wallet_title" />
      </p>
      {hasAvailableReward && (
        <>
          <p className="wallet-reward-input__card-label">
            <FormattedMessage id="wallet.reward.amount" />
          </p>
          <p className="wallet-reward-input__card-amount">
            <Currency currency={currency ?? undefined} />{renderNumber(rewardValue, 2)}
          </p>
          <p className="wallet-reward-input__card-label">
            <FormattedMessage id="wallet.reward.expiration_date" /> {expirationDateFormatted}
          </p>
          <div className="wallet-reward-input__toggle-row">
            <span className="wallet-reward-input__toggle-label">
              <FormattedMessage id="wallet.reward.apply_reward_to_booking" />
            </span>
            <Switch checked={checked} onChange={handleChange} className="wallet-reward-input__switch" disabled={!hasAvailableReward} />
          </div>
        </>)}

      {!hasAvailableReward ? (
        <p className="wallet-reward-input__card-cta">
          <FormattedMessage id="wallet.reward.no_available_rewards" />
        </p>
      ) : !checked ? (
        <p className="wallet-reward-input__card-cta">
          <FormattedMessage id="wallet.reward.apply_to_reduce_total" values={{ amount: amountFormatted }} />
        </p>
      ) : (
        <p className="wallet-reward-input__card-cta wallet-reward-input__card-cta--applied">
          <FormattedMessage id="wallet.reward.applied_to_reduce_total" values={{ amount: amountFormatted }} />
        </p>
      )}
    </div>
  );
}
